import { TransferClientError } from '../../../errors/TransferClientError';
import { Fetch, Params } from '../../shared/types';

import type { Choice, Zap } from '../types';
import getChoiceLabelWithFallback from '../utils/getChoiceLabelWithFallback';

type Options = {
  selected_api: string;
  prefill: string;
  authentication_id?: number;
  params?: Params | {};
  page?: number;
  test_poll?: boolean;
  is_sampling?: boolean;
  zap_id?: Zap['id'];
};

type ResponseData = {
  choices: Array<{
    key: string;
    label: string;
    sample: string;
    value: string;
  }>;
  success: boolean;
};

export const getPrefillChoices = async (
  fetch: Fetch,
  { prefill, ...data }: Options
): Promise<Choice[]> => {
  const [action, valueKey, labelKey] = prefill.split('.');

  const { choices } = await fetch<ResponseData>(
    '/api/v4/implementations/choices/',
    {
      method: 'POST',
      body: {
        selected_api: data.selected_api,
        authentication_id: data.authentication_id,
        params: data.params || {},
        page: data.page,
        prefill,
      },
    }
  );

  return choices.map((result: Record<string, string>) => {
    const label = getChoiceLabelWithFallback(result, valueKey, labelKey);

    if (!label) {
      throw new TransferClientError(
        `Choice for "${data.selected_api}.${action}" has no label.`
      );
    }

    return {
      key: result.key,
      label,
    };
  });
};

export default getPrefillChoices;
